import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { InputFieldWrapper, Label } from "../Events/Datefield";

interface Props {
  label?: string;
  subLabel?: string;
  maxImages: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (e: any) => void;
  name: string;
  uploadedImage: any;
  required: boolean;
  helperText: string;
  urls: any;
  acceptFormats: string;
}

interface StyledInputProps {
  helperText?: string;
  disabled?: boolean;
}

const UploadParkImages = ({
  onChange,
  onRemove,
  label,
  name,
  required,
  helperText,
  subLabel,
  maxImages,
  urls,
  acceptFormats,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        <UploadWrapper helperText={helperText}>
          <div>
            <div>
              {label && (
                <Label>
                  {label}
                  {required && <span>*</span>}
                </Label>
              )}
              {maxImages > 1 && (
                <MaxStatement> (Maximum {maxImages} images)</MaxStatement>
              )}
            </div>
            <SubLabel>{subLabel}</SubLabel>
          </div>
          <InputField
            onChange={onChange}
            name={name}
            autoComplete="off"
            type="file"
            accept={acceptFormats}
            id={name}
            hidden
          />
        </UploadWrapper>
        {helperText && <Error>{helperText}</Error>}
        <AllUploadWrapper>
          <div>
            {Array.apply(null, Array(4)).map((eachUrl: any, i: number) => {
              return (
                <PreviewWrapper>
                  <LabelWrapper key={i}>
                    {urls[i]?.viewUrl ? (
                      <PreviewImage
                        src={urls[i].viewUrl}
                        width="38px"
                        height="38px"
                      />
                    ) : (
                      <DummyPreviewImage />
                    )}
                    <PreviewName>
                      {urls[i]?.originalname || "Tap to upload icon"}
                      <br />
                    </PreviewName>
                  </LabelWrapper>
                  <ActionWrapper>
                    {urls[i]?.viewUrl ? (
                      <PreviewDelete
                        onClick={() => onRemove(urls[i]?.viewUrl)}
                      >
                        <img
                          src={require("../../assets/images/remove_img.png")}
                          alt="delete"
                          width="24px"
                          height="24px"
                        />
                      </PreviewDelete>
                    ) : (
                      <PreviewUpload
                        htmlFor={name}
                      >
                        <img
                          src={require("../../assets/images/upload_img.png")}
                          alt="delete"
                          width="24px"
                          height="24px"
                        />
                      </PreviewUpload>
                    )}
                  </ActionWrapper>
                </PreviewWrapper>
              );
            })}
          </div>
        </AllUploadWrapper>
      </InputFieldWrapper>
    </>
  );
};

const UploadWrapper = styled.div<StyledInputProps>`
  padding: 0.5rem 0;
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${(props) => (props.helperText === "" ? "none" : "red")};
`;

const InputField = styled.input`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 0.75rem;
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;

const AllUploadWrapper = styled.div`
  > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    @media only screen and (max-width: 768px) {
      display: flex;
      flex-direction:column;
    }
  }

`;
const PreviewWrapper = styled.div`
  display: flex;
  border-radius: 0.25rem;
  width: 100%;
  gap: 0.5rem;
`;

const LabelWrapper = styled.div`
  display: flex;
  border: 1px solid ${Colors.athensGray};
  border-radius: 0.25rem;
  background: ${Colors.whiteSmoke};
  flex: 1;
`;

const ActionWrapper = styled.div`
  border: 1px solid ${Colors.athensGray};
  border-radius: 0.25rem;
  background: ${Colors.white};
  width: 3.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PreviewImage = styled.img`
  padding: 0.5rem;
`;

const DummyPreviewImage = styled.div`
  padding: 0.5rem 0.1rem;
  height: 38px;
`;

const PreviewName = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.comet};
  margin-top: 1.25rem;
  margin-left: 0.5rem;
`;

const PreviewDelete = styled.div<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.appleRed};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
`;

const PreviewUpload = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.appleRed};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MaxStatement = styled.span`
  font-family: "Poppins-Book";
  font-style: normal;
  font-size: 0.625rem;
  color: ${Colors.cloudyGrey};
`;
const SubLabel = styled.div`
  font-family: "Poppins-Book";
  font-style: normal;
  font-size: 0.5rem;
  color: ${Colors.cloudyGrey};
  margin-top: 0.5rem;
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default UploadParkImages;
